import { Loader, Modal, Paper, Stack, Text, Image } from "@mantine/core";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
const logoLightSrc = "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/logoLight.png?v=1668237175"
const logoDarkSrc = "https://cdn.shopify.com/s/files/1/0082/0907/2199/files/logoDark.png?v=1668315637"

const discount_code = "HOLIDAY35"
// this was used in 2022 november --> const refParameter = "943EBF20221113SMS1"
// this has now been delegated to the liquid code --> const refParameter = "568264BF20231125SMS1"


function App() {

  const [opened, setOpened] = useState(true)

  useEffect(() => {

    Cookies.set('discount_code', discount_code)
    Cookies.set('ih_discount_app_code', discount_code)
    // this has now been delegated to the liquid code --> Cookies.set('ref', refParameter, { path: '/', domain: '.aikidosteel.com' })
    
    const clearCartAddDiscountCode = (code) => {

       
      fetch("/cart/clear.js", {
        method: 'POST'
      }).then((response) => {
        response.json().then((data) => {
          var promo_code = code;
          //document.cookie = "discount_code=" + promo_code + "; path=/";
          //document.cookie = "ih_discount_app_code=" + promo_code + "; path=/";
          fetch(`/discount/${promo_code}`).then((response) => {
            response.text().then((data) => {
              //window.location = "https://aikidosteel.com/collections/aikido-holiday-35-sale?ref=4528664BFFLASH20231124SMS1"
              //window.location = "https://aikidosteel.com/collections/aikido-steel-black-friday-flash-sale-2024?ref=4528664BFFLASH20231124SMS1"
              window.location = "https://aikidosteel.com/collections/individual-knives?ref=6375461HOLB2G220241210SMS1"
              window.location = "https://aikidosteel.com/collections/aikido-steel-holiday-sale?ref=793564HOLIDAY35VIP20241217SMS1"
              
            });
          });
        });
      });
    }

    setTimeout(() => {
      clearCartAddDiscountCode("HOLIDAY35")
    }, 1500)
/*
    setTimeout(() => {
      window.location.href = "https://aikidosteel.com/cart/clear?return_to=/cart/update?updates[38138627489966]=2"
    }, 3000)
 */   

  }, [])


  return (
    <>
      <Modal centered style={{background: "#000000"}} styles={{modal: {background: "#000000"}}} opened={opened} onClose={()=> {}} withCloseButton={false}>
        <Paper p={20} style={{background: "#000000"}}>
          <Stack align={"center"} spacing={40}>
            <Image style={{margin: "auto"}} src={logoDarkSrc}></Image>
            <Text size={"xl"} color={"white"} align="center">Activating your exclusive offer</Text>
            <Text size={"xl"} mt={-40} color={"#f7b31d"} align="center">GET 35% OFF YOUR ORDER...</Text>
            <Loader color={"white"} size={"xl"}></Loader>
          </Stack>
        </Paper>
        
      </Modal>
    </>
  );
}

export default App;
